<ngx-spinner type="fire" color="#20a8d8" size="large"></ngx-spinner>
<router-outlet></router-outlet>